<template>
   <div class="switch" @click="openSwitch" >
      <div class="switch-bg" :class="{on:cur==1}">
          <div class="switch-btn" :class="{on:cur==1}"></div>
      </div>
    </div>
</template>
<script>
export default {
  name: '',
  props: {
    list: {
      type: Array
    }
  },
  data () {
    return {
      cur: 0
    }
  },
  mounted () {
  },
  methods: {
    openSwitch () {
      this.cur = !this.cur
      this.$emit('selectAll', this.cur)
    }
  }
}
</script>
<style scoped>
.switch{
    width: 80px;
    height: 40px;
    border-radius: 50px;
    border: 1px solid #efefef;
    box-shadow: 2px 2px 5px #8c8c8c;
    position: relative;
}
.switch-btn{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid #f1f1f1;
    position: absolute;
    background-color: #fff;
    top: -1px;
    left: -1px;
    box-shadow: 2px 2px 10px #8c8c8c;
    transition:left .5s;
    -moz-transition:left .5s; /* Firefox 4 */
    -webkit-transition:left .5s; /* Safari and Chrome */
    -o-transition:left .5s; /* Opera */
}
.switch-bg{
    background-color: #570404;
    width: 40px;
    height: 41px;
    border-radius: 50px;
    transition: width .5s;
    -moz-transition: width .5s; /* Firefox 4 */
    -webkit-transition:  width .5s; /* Safari and Chrome */
}
.switch-btn.on{
    left: 40px;
}
.switch-bg.on{
    width: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/select-all.vue